import { useContext, useState } from 'preact/hooks'

import rlxRetailerPlaque from '../assets/rolex-retailer-plaque-500x250_de.jpg?url';
import DownArrow         from './icons/DownArrow.jsx';
import { routes }        from '../data/routes.js';
import GlobalContext     from '../context/GlobalContext.js';
import Link              from './Link.jsx';

const Header = () => {
  const { pathroot } = useContext(GlobalContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);

  // Todo fetch navigation from API
  const nav = [
    {
      title: 'Erfahren Sie mehr über Rolex',
      path: pathroot + routes['discover-rolex'].de
    },
    {
      title: 'Rolex Armbanduhren',
      path: pathroot + routes['watches'].de
    },
    {
      title: 'Neue Modelle 2025',
      path: pathroot + routes['new-watches-2025'].de
    },
    {
      title: 'Uhrmacherkunst',
      path: pathroot + routes['watchmaking'].de
    },
    {
      title: 'Wartung',
      path: pathroot + routes['servicing'].de
    },
    {
      title: 'Die Welt von Rolex',
      path: pathroot + routes['world-of-rolex'].de
    },
    // {
    //   title: `Rolex bei ${retailer.retailer_name}`,
    //   path: pathroot + routes['rolex-at'].de + '/' + slugify(retailer.retailer_name, { lower: true })
    // },
    {
      title: 'Kontaktieren Sie uns',
      path: pathroot + routes['contact-us'].de
    },
  ]

  return (
    <header
      class={`z-50 sm:h-[80px] md:h-[100px] lg:h-[110px] bg-gradient-navigation sm:px-[7%] md:px-[8%] lg:px-[8%]`}>
      <div class="h-full flex items-center relative">
        <div className="">
          <div
            className="sm:w-[100px] sm:h-[50px] md:w-[120px] md:h-[60px] lg:w-[120px] lg:h-[60px] aspect-w-2 aspect-h-1">
            <a href={pathroot === '' ? '/' : pathroot}><img className="w-full h-full object-cover"
                                                            src={rlxRetailerPlaque}
                                                            alt="Rolex Offizieller Fachhändler"/></a>
          </div>
        </div>
        <div className="ml-auto">
          <div className="sm:block md:block lg:block xl:block">
            <button onClick={toggleMenu}
                    className="flex flex-row justify-center items-center text-white">Menü <DownArrow
              class={`ml-[10px] ${menuOpen ? 'rotate-180' : 'rotate-0'}`} height="12px" width="12px"/></button>
          </div>
          {/*<nav className={`sm:hidden md:hidden lg:hidden xl:block`}>*/}
          {/*  <ul className="flex sm:flex-col md:flex-col lg:flex-row">*/}
          {/*    {nav.map((item) => (*/}
          {/*      <li key={item.path} className="ml-[2.5vw]">*/}
          {/*        <Link activeClassName="!text-oceanGreen" class="text-white font-bold hover:text-oceanGreen fixed-14"*/}
          {/*              href={item.path}>{item.title}</Link>*/}
          {/*      </li>*/}
          {/*    ))}*/}
          {/*  </ul>*/}
          {/*</nav>*/}
        </div>
      </div>
      <div>
        {menuOpen && <nav
          class="absolute left-0 right-0 z-50 flex bg-gradient-navigation w-full pt-10 pb-20 px-[8vw] h-[auto]">
          <ul className="flex sm:flex-col md:flex-col lg:flex-col xl:flex-col">
            {nav.map((item) => (
              <li key={item.path} className="ml-[2.5vw] py-4">
                <Link activeClassName="!text-oceanGreen" class="text-white font-bold hover:text-oceanGreen headline-36"
                      href={item.path}>{item.title}</Link>
              </li>
            ))}
          </ul>
        </nav>}
      </div>
    </header>
  );
}

export default Header;
